import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { makeSelectAppInited } from "./app/appSelectors";
import PageError from "./app/PageError.jsx";
import { isClientAndroidNative } from "./components/ClientInfo/ClientInfo";
import MobileSliderPages from "./mobileAppCore/components/MobileSliderPages/MobileSliderPages.jsx";
import { MobileAppStyled } from "./mobileAppCore/components/styled/MobileAppStyled.js";
import { MAP_MOBILE_TO_WEB_ROUTE } from "./mobileAppCore/mobileAppConstants";
import MobileRoutePage from "./mobileAppCore/pages/MobileRoutePage.jsx";
import MobileProviders from "./mobileAppCore/providers/MobileProviders.jsx";
import { GlobalStyles } from "./modules/GlobalStyles/GlobalStyles";
import { useLangContext } from "./providers/LangProvider/LangProviderContext.js";

function MobileApp(props) {
    const {
        isInited,
    } = props;

    const { lang } = useLangContext();

    // check WEB
    if (!isClientAndroidNative) {
        const currentAppPath = document.location.pathname.match(/\/app(.+)/)?.[1];
        const redirectRoute = MAP_MOBILE_TO_WEB_ROUTE[currentAppPath];
        if (redirectRoute) {
            document.location.href = redirectRoute;
        }
    }

    return <>
        {
            isInited && lang && <>
                <GlobalStyles/>
                <MobileProviders> {/* <-- Providers here*/}
                    <MobileAppStyled>
                        {/*<OpenMobileAppBanner/>*/}
                        <MobileRoutePage/>
                        <MobileSliderPages/>
                    </MobileAppStyled>
                </MobileProviders>
            </>
        }
        {
            isInited && !lang && <>
                <GlobalStyles/>
                <PageError
                    code={500}
                    headerText={'Service unavailable'}
                    description={'Sorry, the service is not available'}
                />
            </>
        }
    </>;
}

const mapStateToProps = createStructuredSelector({
    isInited: makeSelectAppInited(),
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MobileApp);
